import {EditorToolType} from '@mc/react-mapio';
import {Feature} from 'geojson';

/**
 * Jeden krok historie geometrie pro funkci "Zpět".
 * Vzniká po dokončení editace geometrie nástroji Editace/Posuv/Otočení/Offset.
 */
export type GeometryUndoStep = {
    /** Unikátní id kroku (klíč pro React). */
    id: string;
    /** Nástroj, kterým změna geometrie vznikla. */
    toolType: EditorToolType;
    /** Popisek kroku pro seznam (např. "Editace"). */
    label: string;
    /**
     * Featury ve stavu PŘED změnou (GeoJSON, připravené k uložení přes updateLayerFeature).
     * Posílá engine v UPDATE eventu jako `previousFeatures`. Použije se při vrácení kroku ("Zpět").
     */
    beforeFeatures: Feature[];
    /**
     * Featury ve stavu PO změně (GeoJSON = `features` z UPDATE eventu).
     * Použije se při opětovném provedení kroku ("Vpřed" / redo).
     */
    afterFeatures: Feature[];
    /** Čas vzniku kroku (ms). */
    timestamp: number;
};

/** Maximální počet kroků držených v historii (dle zadání MCW-28392). */
export const MAX_UNDO_STEPS = 5;

/**
 * Nástroje, jejichž změny geometrie sleduje funkce "Zpět", spolu s popisky do seznamu.
 * Ostatní nástroje se do historie nezaznamenávají (viz zadání – dopad na evidenční údaje pasportů).
 */
export const UNDO_TOOL_LABELS: Partial<Record<EditorToolType, string>> = {
    [EditorToolType.EDIT]: 'Editace',
    [EditorToolType.MOVE]: 'Posuv',
    [EditorToolType.ROTATE]: 'Otočení',
    [EditorToolType.OFFSET]: 'Offset',
};
